import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Flags from 'country-flag-icons/react/3x2';

interface Props {
    className: string
    itemRef?: React.Ref<any>
    name: string,
    iso2: string,
    dialCode: string,
    localization: string,
    native: boolean,
    [key: string]: any
}

const Item = (props: Props) => {
    const {
        name, iso2, dialCode, localization, itemRef,
        native, className = '', ...restProps
    } = props;

    if (native) {
        return (
            <option
                className="country"
                data-dial-code="1"
                data-country-code={iso2}
                value={iso2}
                {...restProps}
            >
                {localization || name}
                {' '}
                {`+${dialCode}`}
            </option>
        );
    }

    const upperIso2 = (iso2 as string).toUpperCase();

    const FlagComponent = (Flags as any)[upperIso2] ?? null;

    return (
        <MenuItem
            ref={itemRef}
            className="country"
            data-dial-code="1"
            data-country-code={iso2}
            {...restProps}
        >
            {Boolean(FlagComponent) && (
                <div className={className}>
                    <FlagComponent />
                </div>
            )}

            <span className="country-name">
                {localization || name}
            </span>

            <span className="dial-code">{`+${dialCode}`}</span>
        </MenuItem>
    );
};

export default Item;
